function scroll2(section) {
	section = ge(section);
	targetScroll = section.getBoundingClientRect().top + mainView.scrollTop - 100;
	if ((mainWrapper.scrollHeight - targetScroll) < winH)
		targetScroll = mainWrapper.scrollHeight - winH;
	moveScroll();
}

function moveScroll() {
	var scroll = mainView.scrollTop;
	var distance = targetScroll - scroll;
	if (distance < 0) return;

	if (velocity < maxVelocity && stopDist * 2 < distance) {
		velocity = velocity + acceleration;
		stopDist = ((velocity / 2) * (velocity / acceleration));
	}

	if (distance < velocity) {
		// stop
		mainView.scrollTo(0, targetScroll);
		velocity = 0;
		stopDist = 0;
		targetScroll = null;
	}
	else {
		if (distance < stopDist && minVelocity < velocity - acceleration) {
			// slow down
			velocity = velocity - acceleration;
		}
		mainView.scrollTo(0, scroll + velocity);
	}

	// animateScroll();
	if (targetScroll !== null) setTimeout(moveScroll, 15);
}
function init(){
	winH = window.innerHeight;
	winW = window.innerWidth;
	middle = winH * 0.5;
	animateScroll();
}

function animateScroll() {
	let scroll = mainView.scrollTop;

	for (let i = 0, ii = animateImages.length; i < ii; i++) {
		let img = animateImages[i];
		let top = img.getBoundingClientRect().top;

		let topLimit = img.hasAttribute('data-out') ? (img.getAttribute('data-out') / 100 * winH) < top : true;

		if ((img.getAttribute('data-in') / 100) * winH > top && topLimit) {
			img.className = img.className.replace(/off/g, 'on');
		}
		else {
			img.className = img.className.replace(/on/g, 'off');
		}
	}

	for (let i = 0, ii = animateTexts.length; i < ii; i++) {
		let text = animateTexts[i];
		let top = text.getBoundingClientRect().top;

		if ((text.getAttribute('data-in') / 100) * winH > top) {
			text.className = text.className.replace(/off/g, 'on');
		}
		else {
			text.className = text.className.replace(/on/g, 'off');
		}
	}
}

